export const HIDDEN_POLICY_NAMES: string[] = [
  'PersonaSignonPolicy'
];

export function shouldHidePolicy(
  policyName: string | null | undefined,
  isCustomerCitusEnabled: boolean
): boolean {
  if (!isCustomerCitusEnabled) {
    return false;
  }

  if (!policyName || typeof policyName !== 'string') {
    return false;
  }

  const trimmedPolicyName = policyName.trim();

  if (!trimmedPolicyName) {
    return false;
  }

  const policyNameLower = trimmedPolicyName.toLowerCase();

  return HIDDEN_POLICY_NAMES.some(hiddenName => {
    if (!hiddenName || typeof hiddenName !== 'string') {
      return false;
    }

    const trimmedHiddenName = hiddenName.trim();
    if (!trimmedHiddenName) {
      return false;
    }

    const hiddenNameLower = trimmedHiddenName.toLowerCase();
    return policyNameLower === hiddenNameLower;
  });
}

